export default __webpack_public_path__ + "static/media/Inter.var.9df5db38.woff2";